module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "ch",
    class: [
      'epg__timeslots',
      'epg__channel-row', {
        'epg__channel-row--expanded': _vm.channel._isSelected
      }
    ],
    style: (("height:" + ((_vm.channel._isSelected) ? _vm.defaultTimeSlotHeight+_vm.expandedSlotHeight : _vm.defaultTimeSlotHeight) + "px"))
  }, [(_vm.inViewport) ? _c('div', _vm._l((_vm.channel.slots), function(n, index) {
    return _c('Program', {
      key: n.id,
      attrs: {
        "timeline-rect": _vm.timelineRect,
        "horizontal-debounce": _vm.horizontalDebounce,
        "is-grabbed": _vm.isGrabbed,
        "program": n,
        "pixels-per-minute": _vm.pixelsPerMinute,
        "container-pos": _vm.containerPos,
        "timeline-width": _vm.timelineWidth,
        "selectProgram": _vm.selectProgram,
        "more-label": _vm.moreLabel,
        "less-label": _vm.lessLabel,
        "close-slot": _vm.closeSlot,
        "set-expanded-slot-height": _vm.setExpandedSlotHeight,
        "expanded-slot-height": _vm.expandedSlotHeight,
        "show-program-loader": _vm.showProgramLoader,
        "selected-program": _vm.selectedProgram,
        "description-truncation-point": _vm.descriptionTruncationPoint
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-261db864"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChannelRow/ChannelRow.vue
// module id = 232
// module chunks = 1